import React from 'react'
import { render } from 'react-dom'
import { browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import Root from 'container/Root'
import configureStore from 'store'
import { LOGIN_SUCCESS, FETCH_MENUS_SUCCESS } from 'actionTypes'
import initDatadog, { setDatadogUser } from 'config/datadog'
import User from 'utils/User'
import 'react-dates/lib/css/_datepicker.css'
import 'styles/main.css'

import checkLocalVersion from 'utils/checkLocalVersion'

// Creates aplication store
const store = configureStore()

// Use meta.json to check if app is outdated and clears cache
checkLocalVersion()

// Starts browser observability
initDatadog()

// Creates a new User instance in order to check if there is any user in cache
const user = new User()
const { currentUser } = user

// In case there is an user and menu in cache, logs in
if (currentUser) {
  setDatadogUser(currentUser)
  store.dispatch({ type: LOGIN_SUCCESS, payload: currentUser })

  if (user.menu) {
    store.dispatch({ type: FETCH_MENUS_SUCCESS, payload: user.menu })
  }
} else {
  user.clearCache()
}

// Syncronizes browserHistory with Store
const history = syncHistoryWithStore(browserHistory, store)

// DOM target to render react components
const target = document.getElementById('root')

// Renders Root component in HTML target
render(<Root store={store} history={history} />, target)
